import { render } from "./manage-driver.vue?vue&type=template&id=4984c44a&scoped=true"
import script from "./manage-driver.vue?vue&type=script&lang=js"
export * from "./manage-driver.vue?vue&type=script&lang=js"

import "./manage-driver.vue?vue&type=style&index=0&id=4984c44a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4984c44a"]])

export default __exports__